// extracted by mini-css-extract-plugin
var _1 = "container--Ei5grAtN";
export { _1 as "container" }
